<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 225 200"
  width="222px"
  height="200px"
  preserveAspectRatio="xMidYMid meet"
>
  <g id="scorpion" transform="translate(2,0)">
    <g id="right-wing">
      <path
        d="M169.712 32.9976L138.469 69.9468C138.469 69.9468 137.112 71.1126 135.178 71.1126C134.149 71.1126 128.718 70.7835 123.836 70.4817V90.8628C123.836 92.4675 122.725 94.8265 121.463 98.0222C121.518 97.9948 121.573 97.9399 121.627 97.8713C123.685 95.1146 169.794 39.9787 173.47 35.5898C171.947 35.1646 170.631 34.2457 169.712 33.0113V32.9976Z"
        [attr.fill]="wingRightColor"
        stroke="#5C5C5C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M175.389 35.8791C179.313 35.8791 182.494 32.6982 182.494 28.7745C182.494 24.8507 179.313 21.6699 175.389 21.6699C171.466 21.6699 168.285 24.8507 168.285 28.7745C168.285 32.6982 171.466 35.8791 175.389 35.8791Z"
        [attr.fill]="wingRightColor"
        stroke="#5C5C5C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M220.758 41.4226C218.988 40.682 194.754 30.7383 188.349 28.1187C187.321 27.6935 186.237 27.4878 185.126 27.4878H182.356C182.438 27.913 182.479 28.3381 182.479 28.777C182.479 30.3269 181.972 31.7533 181.122 32.9191L184.482 39.8316C187.321 40.4351 217.274 46.8539 219.331 47.1831C221.402 47.5123 222.691 47.622 222.691 47.622C222.691 47.622 223.171 42.4376 220.758 41.4363V41.4226Z"
        [attr.fill]="wingRightColor"
        stroke="#5C5C5C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M168.298 28.7716C168.298 27.1532 168.86 25.6856 169.765 24.4924L166.048 16.8255C163.209 16.222 133.256 9.80322 131.199 9.47405C129.128 9.14488 127.839 9.03516 127.839 9.03516C127.839 9.03516 127.359 14.2196 129.772 15.2208C131.542 15.9614 155.776 25.9051 162.181 28.5247C163.209 28.9499 164.293 29.1556 165.404 29.1556H168.339C168.339 29.0185 168.298 28.8951 168.298 28.7716Z"
        [attr.fill]="wingRightColor"
        stroke="#5C5C5C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M138.469 70.0137L141.897 73.2368"
        stroke="#969696"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="none"
      />
      <path
        d="M169.712 33.0645L138.469 70.0137C138.469 70.0137 137.112 71.1795 135.178 71.1795C134.149 71.1795 128.718 70.8504 123.836 70.5486V90.9297C123.836 92.5344 122.725 94.8934 121.463 98.0891C121.518 98.0617 121.573 98.0068 121.627 97.9382C123.685 95.1814 169.794 40.0456 173.47 35.6567C171.947 35.2315 170.631 34.3126 169.712 33.0782V33.0645Z"
        stroke="#5C5C5C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="none"
      />
      <path
        d="M175.389 35.9455C179.313 35.9455 182.494 32.7646 182.494 28.8409C182.494 24.9172 179.313 21.7363 175.389 21.7363C171.466 21.7363 168.285 24.9172 168.285 28.8409C168.285 32.7646 171.466 35.9455 175.389 35.9455Z"
        stroke="#5C5C5C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="none"
      />
      <path
        d="M173.469 24.71C172.426 24.71 171.453 24.9431 170.575 25.3409C170.561 25.5466 170.506 25.7386 170.506 25.9581C170.506 29.8807 173.688 33.0626 177.611 33.0626C178.653 33.0626 179.627 32.8295 180.505 32.4317C180.518 32.226 180.573 32.034 180.573 31.8145C180.573 27.8919 177.391 24.71 173.469 24.71Z"
        stroke="#969696"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="none"
      />
      <path
        d="M220.758 41.4885C218.988 40.7479 194.754 30.8043 188.349 28.1846C187.321 27.7594 186.237 27.5537 185.126 27.5537H182.356C182.438 27.9789 182.479 28.4041 182.479 28.843C182.479 30.3928 181.972 31.8192 181.122 32.985L184.482 39.8976C187.321 40.501 217.274 46.9198 219.331 47.249C221.402 47.5782 222.691 47.6879 222.691 47.6879C222.691 47.6879 223.171 42.5035 220.758 41.5023V41.4885Z"
        stroke="#5C5C5C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="none"
      />
      <path
        d="M168.298 28.838C168.298 27.2196 168.86 25.7521 169.765 24.5588L166.048 16.8919C163.209 16.2884 133.256 9.86962 131.199 9.54046C129.128 9.21129 127.839 9.10156 127.839 9.10156C127.839 9.10156 127.359 14.286 129.772 15.2872C131.542 16.0278 155.776 25.9715 162.181 28.5911C163.209 29.0163 164.293 29.222 165.404 29.222H168.339C168.339 29.0849 168.298 28.9615 168.298 28.838Z"
        stroke="#5C5C5C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="none"
      />
    </g>
    <g id="left-wing">
      <path
        d="M100.097 90.9258V70.5447C95.2146 70.8464 89.7835 71.1756 88.7549 71.1756C86.8211 71.1756 85.4633 70.0098 85.4633 70.0098L54.2208 33.0605C53.3019 34.2949 51.9852 35.2139 50.4629 35.639C54.1385 40.028 100.248 95.1638 102.305 97.9206C102.36 97.9892 102.415 98.0441 102.47 98.0715C101.208 94.8758 100.097 92.5168 100.097 90.9121V90.9258Z"
        stroke="#5C5C5C"
        [attr.fill]="wingLeftColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M48.5408 35.9489C52.4644 35.9489 55.6452 32.7681 55.6452 28.8443C55.6452 24.9206 52.4644 21.7397 48.5408 21.7397C44.6172 21.7397 41.4365 24.9206 41.4365 28.8443C41.4365 32.7681 44.6172 35.9489 48.5408 35.9489Z"
        [attr.fill]="wingLeftColor"
        stroke="#5C5C5C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.17286 41.4226C4.94208 40.682 29.1763 30.7383 35.5811 28.1187C36.6098 27.6935 37.6932 27.4878 38.8041 27.4878H41.5746C41.4923 27.913 41.4511 28.3381 41.4511 28.777C41.4511 30.3269 41.9586 31.7533 42.8089 32.9191L39.4487 39.8316C36.6098 40.4351 6.65644 46.8539 4.59921 47.1831C2.52826 47.5123 1.23906 47.622 1.23906 47.622C1.23906 47.622 0.759042 42.4376 3.17286 41.4363V41.4226Z"
        [attr.fill]="wingLeftColor"
        stroke="#5C5C5C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M55.6462 28.7741C55.6462 27.1556 55.0839 25.6881 54.1787 24.4948L57.8954 16.8279C60.7344 16.2245 90.6878 9.80566 92.745 9.47649C94.8159 9.14732 96.1051 9.0376 96.1051 9.0376C96.1051 9.0376 96.5852 14.222 94.1713 15.2232C92.4021 15.9639 68.1679 25.9075 61.763 28.5272C60.7344 28.9524 59.651 29.1581 58.54 29.1581H55.6051C55.6051 29.0209 55.6462 28.8975 55.6462 28.7741Z"
        [attr.fill]="wingLeftColor"
        stroke="#5C5C5C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M100.097 90.8599V70.4788C95.2146 70.7805 89.7835 71.1097 88.7549 71.1097C86.8211 71.1097 85.4633 69.9439 85.4633 69.9439L54.2208 32.9946C53.3019 34.229 51.9852 35.1479 50.4629 35.5731C54.1385 39.962 100.248 95.0979 102.305 97.8547C102.36 97.9233 102.415 97.9781 102.47 98.0056C101.208 94.8099 100.097 92.4509 100.097 90.8461V90.8599Z"
        fill="none"
        stroke="#5C5C5C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M48.5408 35.8825C52.4644 35.8825 55.6452 32.7017 55.6452 28.7779C55.6452 24.8542 52.4644 21.6733 48.5408 21.6733C44.6172 21.6733 41.4365 24.8542 41.4365 28.7779C41.4365 32.7017 44.6172 35.8825 48.5408 35.8825Z"
        fill="none"
        stroke="#5C5C5C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path
        d="M85.4629 70.0146L82.0479 73.2378"
        fill="none"
        stroke="#969696"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <path
        d="M50.4627 24.7129C51.505 24.7129 52.4788 24.9461 53.3566 25.3438C53.3703 25.5495 53.4251 25.7415 53.4251 25.961C53.4251 29.8836 50.2433 33.0656 46.3208 33.0656C45.2785 33.0656 44.3047 32.8324 43.427 32.4347C43.4133 32.2289 43.3584 32.0369 43.3584 31.8175C43.3584 27.8949 46.5403 24.7129 50.4627 24.7129Z"
        fill="none"
        stroke="#969696"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.17286 41.4885C4.94208 40.7479 29.1763 30.8043 35.5811 28.1846C36.6098 27.7594 37.6932 27.5537 38.8041 27.5537H41.5746C41.4923 27.9789 41.4511 28.4041 41.4511 28.843C41.4511 30.3928 41.9586 31.8192 42.8089 32.985L39.4487 39.8976C36.6098 40.501 6.65644 46.9198 4.59921 47.249C2.52826 47.5782 1.23906 47.6879 1.23906 47.6879C1.23906 47.6879 0.759042 42.5035 3.17286 41.5023V41.4885Z"
        fill="none"
        stroke="#5C5C5C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M55.6462 28.8405C55.6462 27.222 55.0839 25.7545 54.1787 24.5613L57.8954 16.8943C60.7344 16.2909 90.6878 9.87207 92.745 9.5429C94.8159 9.21373 96.1051 9.104 96.1051 9.104C96.1051 9.104 96.5852 14.2884 94.1713 15.2896C92.4021 16.0303 68.1679 25.9739 61.763 28.5936C60.7344 29.0188 59.651 29.2245 58.54 29.2245H55.6051C55.6051 29.0873 55.6462 28.9639 55.6462 28.8405Z"
        fill="none"
        stroke="#5C5C5C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <g id="tail">
      <path
        d="M112.397 173.551C116.04 173.551 118.994 170.598 118.994 166.954C118.994 163.311 116.04 160.357 112.397 160.357C108.753 160.357 105.8 163.311 105.8 166.954C105.8 170.598 108.753 173.551 112.397 173.551Z"
        [attr.fill]="tailColor"
      />
      <path
        d="M142.158 134.915C140.8 136.054 122.271 151.812 117.375 155.982C116.593 156.654 115.949 157.463 115.482 158.368L114.303 160.659C114.687 160.769 115.057 160.919 115.427 161.098C116.703 161.756 117.663 162.785 118.266 163.978L125.398 164.156C127.099 162.072 145.148 140.1 146.3 138.536C147.452 136.972 148.096 135.957 148.096 135.957C148.096 135.957 144.023 133.352 142.171 134.915H142.158Z"
        [attr.fill]="tailColor"
      />
      <path
        d="M109.366 172.809C108.036 172.123 107.048 171.026 106.458 169.764L98.5448 169.572C96.8442 171.657 78.7954 193.629 77.6433 195.192C76.4913 196.756 75.8467 197.771 75.8467 197.771C75.8467 197.771 79.92 200.377 81.7715 198.813C83.1293 197.675 101.658 181.916 106.554 177.746C107.336 177.074 107.981 176.265 108.447 175.36L109.695 172.946C109.585 172.891 109.462 172.863 109.352 172.809H109.366Z"
        [attr.fill]="tailColor"
      />
      <path
        d="M115.51 161.168C115.483 161.141 115.414 161.099 115.414 161.099C113.083 159.906 110.381 160.249 108.42 161.73L108.159 137.021H115.963L115.51 161.168Z"
        [attr.fill]="tailColor"
      />
      <path
        d="M108.173 166.789C107.734 167.639 107.514 168.544 107.459 169.45C107.624 169.546 107.761 169.669 107.939 169.765C111.176 171.438 115.154 170.163 116.827 166.926C117.266 166.076 117.485 165.171 117.54 164.265C117.375 164.169 117.238 164.046 117.06 163.95C113.823 162.277 109.846 163.552 108.173 166.789Z"
        fill="none"
      />
      <path
        d="M112.397 173.552C116.04 173.552 118.994 170.598 118.994 166.955C118.994 163.312 116.04 160.358 112.397 160.358C108.753 160.358 105.8 163.312 105.8 166.955C105.8 170.598 108.753 173.552 112.397 173.552Z"
        fill="none"
        stroke="#5C5C5C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M142.158 134.916C140.8 136.054 122.271 151.813 117.375 155.983C116.593 156.655 115.949 157.464 115.482 158.369L114.303 160.66C114.687 160.77 115.057 160.92 115.427 161.099C116.703 161.757 117.663 162.786 118.266 163.979L125.398 164.157C127.099 162.073 145.148 140.101 146.3 138.537C147.452 136.973 148.096 135.958 148.096 135.958C148.096 135.958 144.023 133.353 142.171 134.916H142.158Z"
        fill="none"
        stroke="#5C5C5C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M109.366 172.81C108.036 172.124 107.048 171.027 106.458 169.765L98.5448 169.573C96.8442 171.657 78.7954 193.63 77.6433 195.193C76.4913 196.757 75.8467 197.772 75.8467 197.772C75.8467 197.772 79.92 200.378 81.7715 198.814C83.1293 197.676 101.658 181.917 106.554 177.747C107.336 177.075 107.981 176.266 108.447 175.361L109.695 172.947C109.585 172.892 109.462 172.864 109.352 172.81H109.366Z"
        fill="none"
        stroke="#5C5C5C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M115.51 161.169C115.483 161.142 115.414 161.1 115.414 161.1C113.083 159.907 110.381 160.25 108.42 161.731L108.159 137.022H115.963L115.51 161.169Z"
        fill="none"
        stroke="#5C5C5C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M112.397 173.618C116.04 173.618 118.994 170.664 118.994 167.021C118.994 163.377 116.04 160.424 112.397 160.424C108.753 160.424 105.8 163.377 105.8 167.021C105.8 170.664 108.753 173.618 112.397 173.618Z"
        fill="none"
        stroke="#5C5C5C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M108.173 166.856C107.734 167.706 107.514 168.611 107.459 169.517C107.624 169.613 107.761 169.736 107.939 169.832C111.176 171.505 115.154 170.23 116.827 166.993C117.266 166.143 117.485 165.237 117.54 164.332C117.375 164.236 117.238 164.113 117.06 164.017C113.823 162.343 109.846 163.619 108.173 166.856Z"
        fill="none"
        stroke="#969696"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M142.158 134.982C140.8 136.12 122.271 151.879 117.375 156.049C116.593 156.721 115.949 157.53 115.482 158.435L114.303 160.726C114.687 160.836 115.057 160.986 115.427 161.165C116.703 161.823 117.663 162.852 118.266 164.045L125.398 164.223C127.099 162.138 145.148 140.166 146.3 138.603C147.452 137.039 148.096 136.024 148.096 136.024C148.096 136.024 144.023 133.418 142.171 134.982H142.158Z"
        fill="none"
        stroke="#5C5C5C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M109.366 172.876C108.036 172.19 107.048 171.093 106.458 169.831L98.5448 169.639C96.8442 171.723 78.7954 193.695 77.6433 195.259C76.4913 196.823 75.8467 197.838 75.8467 197.838C75.8467 197.838 79.92 200.443 81.7715 198.88C83.1293 197.742 101.658 181.983 106.554 177.813C107.336 177.141 107.981 176.332 108.447 175.427L109.695 173.013C109.585 172.958 109.462 172.93 109.352 172.876H109.366Z"
        fill="none"
        stroke="#5C5C5C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M115.51 161.235C115.483 161.207 115.414 161.166 115.414 161.166C113.083 159.973 110.381 160.316 108.42 161.797L108.159 137.088H115.963L115.51 161.235Z"
        fill="none"
        stroke="#5C5C5C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <g id="body">
      <path
        d="M123.894 57.3846V53.1932H136.18V52.2175C131.397 45.7449 123.894 46.7893 123.894 46.7893C123.894 13.423 111.993 1 111.993 1C111.993 1 100.092 13.423 100.092 46.7893C100.092 46.7893 92.589 45.7587 87.8066 52.2175V53.1932H100.092V79.4685H95.2687C93.6471 79.4685 92.3416 80.774 92.3416 82.3956C92.3416 84.0172 93.6471 85.3227 95.2687 85.3227H100.092V90.4898C100.092 94.1178 105.782 101.621 106.043 113.769C106.139 118.455 106.414 127.209 106.73 137.021H117.284H117.256C117.572 127.209 117.834 118.455 117.944 113.769C118.205 101.621 123.894 94.1041 123.894 90.4898V85.3227H128.717C130.339 85.3227 131.645 84.0172 131.645 82.3956C131.645 80.774 130.325 79.4685 128.717 79.4685H123.894V57.3709V57.3846Z"
        fill="none"
      />
      <path
        d="M100.092 86.6963C103.198 87.672 106.812 91.9321 108.434 96.8518C108.874 98.1711 109.176 99.188 109.382 99.9714C109.712 101.236 108.75 102.472 107.431 102.472H104.27"
        fill="none"
        stroke="#969696"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M123.894 86.6963C120.788 87.672 117.174 91.9321 115.553 96.8518C115.113 98.1711 114.81 99.188 114.604 99.9714C114.274 101.236 115.236 102.472 116.556 102.472H119.716"
        fill="none"
        stroke="#969696"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M128.731 79.4824H95.2689C93.6523 79.4824 92.3418 80.7929 92.3418 82.4095V82.4233C92.3418 84.0399 93.6523 85.3504 95.2689 85.3504H128.731C130.348 85.3504 131.659 84.0399 131.659 82.4233V82.4095C131.659 80.7929 130.348 79.4824 128.731 79.4824Z"
        fill="none"
        stroke="#5C5C5C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M100.092 85.3369V90.504C100.092 94.132 105.782 101.635 106.043 113.783C106.139 118.47 106.414 127.223 106.73 137.035H117.284H117.256C117.572 127.223 117.834 118.47 117.944 113.783C118.205 101.635 123.894 94.1182 123.894 90.504V85.3369"
        fill="none"
        stroke="#5C5C5C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M102.112 56.4072C101.288 56.4072 100.573 56.792 100.092 57.3829V60.6811C100.573 61.272 101.302 61.6568 102.112 61.6568C103.555 61.6568 104.737 60.4887 104.737 59.032C104.737 57.5753 103.569 56.4072 102.112 56.4072Z"
        fill="none"
        stroke="#969696"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M121.874 56.4072C122.698 56.4072 123.413 56.792 123.894 57.3829V60.6811C123.413 61.272 122.685 61.6568 121.874 61.6568C120.431 61.6568 119.249 60.4887 119.249 59.032C119.249 57.5753 120.417 56.4072 121.874 56.4072Z"
        fill="none"
        stroke="#969696"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M121.572 56.4493V43.3254C121.572 41.7588 120.459 40.3983 118.92 40.0823C114.302 39.134 109.685 39.134 105.067 40.0823C103.528 40.3983 102.415 41.7451 102.415 43.3254V56.4493C103.721 56.6005 104.737 57.6999 104.737 59.0466C104.737 60.3934 103.721 61.4928 102.415 61.6439V72.7889C102.415 74.6029 103.885 76.0733 105.699 76.0733H118.274C120.088 76.0733 121.558 74.6029 121.558 72.7889V61.6439C120.253 61.4928 119.236 60.3934 119.236 59.0466C119.236 57.6999 120.253 56.6005 121.558 56.4493H121.572Z"
        fill="none"
        stroke="#969696"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M111.993 10.7139V28.304"
        fill="none"
        stroke="#969696"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M114.26 28.3047H109.739V39.381H114.26V28.3047Z"
        fill="none"
        stroke="#969696"
        stroke-width="1"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M111.993 1.0127C111.993 1.0127 100.092 13.4357 100.092 46.802V79.4812"
        fill="none"
        stroke="#5C5C5C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M111.993 1.0127C111.993 1.0127 123.894 13.4357 123.894 46.802C123.894 63.1966 123.894 73.1598 123.894 79.4812"
        fill="none"
        stroke="#5C5C5C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M100.092 46.8015C100.092 46.8015 92.589 45.7709 87.8066 52.2297V53.2054H100.092"
        fill="none"
        stroke="#5C5C5C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M123.894 46.8015C123.894 46.8015 131.397 45.7709 136.18 52.2297V53.2054H123.894"
        fill="none"
        stroke="#5C5C5C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </g>
</svg>
<ng-container *ngFor="let part of validParts">
  <app-drone-model-vector-table
    [part]="part"
    modelType="scorpion"
  ></app-drone-model-vector-table>
</ng-container>
